<template>
  <div>
    <section class="section title-background">
      <div class="container">
        <div class="columns">
          <div class="column">
            <div class="m-2">
              <h2 class="title is-size-2">REDES SOCIALES</h2>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="container">

      <div class="columns mt-01">

        <div class="column">
          <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fmariomachucasanchez%2F&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=123080025087877" width="340" height="500" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
        </div>
        <div class="column">
          <timeline id="MarioMachucaS" sourceType="profile" :options="{ tweetLimit: '2'}"></timeline>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {Timeline} from 'vue-tweet-embed'

export default {
  name: 'RedesSociales',
  data () {
    return {

    }
  },
  computed: {
  },
  components: {
    'timeline': Timeline,
  },
  mounted() {

  },
  methods:{

  },
  created :function(){
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/RedesSociales.vue